import qs from 'query-string'

export function currentParams() {
  const params = qs.parse(window.location.search)
  delete params[''] // fix where "&&" in url creates empty object
  return params
}

export function multifyParams(args, argname, argdelimiter) {
  const delimiter = argdelimiter || ' ' // Space as default
  if (args) {
    const argsin = (args.endsWith(delimiter)) ? args.slice(0, -1) : args // Remove last delimiter
    const argsout = argsin.split(delimiter)
    const params = argsout.map(i => `${argname  }=${  i}`).join('&')
    return parseParams(params)
  }
}

export function parseParams(params) {
  return qs.parse(params)
}

export function stringifyParams(params) {
  return qs.stringify(params)
}

export function slugifyParam(param) {
  return param.normalize('NFD').toLowerCase()
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/([^\w]+|\s+)/g, '_')
    .replace(/\_\_+/g, '_')
    .replace(/(^_+|_+$)/g, '')
}
